import styled from "styled-components";
import { Row, Col, Divider, Grid, Collapse } from "antd";

import { RALink, RATypography } from "@/components/customs";
import { RAImage } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { SvgPhone, SvgArrowDown } from "@/assets/icons";
import { PATH_ROUTES } from "@/config/routes";

const { useBreakpoint } = Grid;
const { Panel } = Collapse;

export function MainFooter() {
	const screens = useBreakpoint();

	return (
		<>
			{screens?.md ? (
				<BodyContainer>
					<ContainerFooter>
						<WrapperContent>
							<Row style={{ width: "100%" }} gutter={[28, 28]}>
								<Col xl={6} md={24} sm={24} xs={24}>
									<RAImage url={PATH_PUBLIC_IMAGES.logo} width="160px" height="60px" />
									<RATypography
										variant="body3"
										whiteSpace="pre-wrap"
										color="#595959"
										bottom="16px"
										top="16px"
									>
										Elevate your journey and achieve your mission with Royal Air, where 60 years of
										expertise converge to create extraordinary experiences.
									</RATypography>
									<WrapperLink>
										<WrapperPhone>
											<div
												style={{
													minWidth: 22,
													minHeight: 22,
												}}
											>
												<SvgPhone color="#353535" />
											</div>
											<a href="tel:+12488869309">
												<RATypography>+1 248 886 9309</RATypography>
											</a>
										</WrapperPhone>
									</WrapperLink>
								</Col>
								<Col xl={6} md={8} sm={24} xs={24}>
									<RATypography variant="h4" bottom="16px">
										Company
									</RATypography>
									<WrapperLink>
										<RALink title="Journey" href={PATH_ROUTES.PATH_JOURNEY} />
										<RALink
											title="Flight Request"
											href={PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL}
										/>
										<RALink title="Contact" href={PATH_ROUTES.PATH_CONTACT_US} />
										<RALink title="Careers" href={`${PATH_ROUTES.PATH_CONTACT_US}/#career`} />
									</WrapperLink>
								</Col>
								<Col xl={6} md={8} sm={24} xs={24}>
									<RATypography variant="h4" bottom="16px">
										Services
									</RATypography>
									<WrapperLink>
										<RALink
											title="Private Jet Travel"
											href={PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL}
										/>
										<RALink title="Jet 1 Suites" href={PATH_ROUTES.PATH_SERVICE_JET_ONE_SUITES} />
										<RALink title="Air Freight" href={PATH_ROUTES.PATH_SERVICE_AIR_FREIGHT} />
									</WrapperLink>
								</Col>
								<Col xl={6} md={8} sm={24} xs={24}>
									<RATypography variant="h4" bottom="16px">
										{"Help & Support"}
									</RATypography>
									<WrapperLink>
										<RALink title="Privacy Policy" href={PATH_ROUTES.PATH_PRIVACY_POLICY} />
										<RALink title="Cookie Policy" href={PATH_ROUTES.PATH_COOKIE_POLICY} />
										<RALink title="Terms & Conditions" href={PATH_ROUTES.PATH_TERM_CONDITIONS} />
										<RALink title="FAQs" href={PATH_ROUTES.PATH_FAQs} />
									</WrapperLink>
								</Col>
							</Row>
						</WrapperContent>
						<Divider />
						<WrapperEnding>
							<RATypography variant="sub-heading4" align="center">
								Copyright © 2026 Royal Air Charter. All Rights Reserved.
							</RATypography>
							<RATypography variant="p" align="center" color="#595959" top={8}>
								Royal Air Charter operates flights under FAA Part 135 certificate BUHA637C. On certain
								occasions, flights may be arranged through our broker authority under 14 CFR Part 295,
								in which case flights will be operated by an FAA-certificated air carrier with
								operational control.
							</RATypography>
						</WrapperEnding>
					</ContainerFooter>
				</BodyContainer>
			) : (
				<WrapperCardMd>
					<ContainerFooter>
						<Row style={{ width: "100%" }}>
							<RAImage url={PATH_PUBLIC_IMAGES.logo} width="160px" height="60px" objectFit="contain" />
						</Row>
						<Row style={{ width: "100%" }}>
							<RATypography
								variant="body3"
								whiteSpace="pre-wrap"
								color="#595959"
								bottom="16px"
								top="16px"
							>
								Elevate your journey and achieve your mission with Royal Air, where 60 years of
								expertise converge to create extraordinary experiences.
							</RATypography>
						</Row>
						<Row style={{ width: "100%" }}>
							<WrapperLink>
								<WrapperPhone>
									<SvgPhone color="#353535" />
									<a href="tel:+12488869309">
										<RATypography>+1 248 886 9309</RATypography>
									</a>
								</WrapperPhone>
							</WrapperLink>
						</Row>
						<Row style={{ width: "100%", height: "100%" }}>
							<Collapse
								style={{
									width: "100%",
									backgroundColor: "#fff",
								}}
								// defaultActiveKey={["1", "2", "3"]}
								bordered={false}
								expandIconPosition={"end"}
								ghost
								expandIcon={({ isActive }) => {
									return (
										<div
											style={{
												transition: "transform 0.2s",
												transform: !isActive ? `rotate(0turn)` : "rotate(0.5turn)",
											}}
										>
											<SvgArrowDown width={16} color="#595959" />
										</div>
									);
								}}
							>
								<Panel header={<RATypography variant="h5">Company</RATypography>} key="1">
									<WrapperLink>
										<RALink title="Journey" href={PATH_ROUTES.PATH_JOURNEY} />
										<RALink
											title="Flight Request"
											href={PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL}
										/>
										<RALink title="Contact" href={PATH_ROUTES.PATH_CONTACT_US} />
										<RALink title="Careers" href={`${PATH_ROUTES.PATH_CONTACT_US}/#career`} />
									</WrapperLink>
								</Panel>
								<Panel header={<RATypography variant="h5">Services</RATypography>} key="2">
									<WrapperLink>
										<RALink
											title="Private Jet Travel"
											href={PATH_ROUTES.PATH_SERVICE_PRIVATE_JET_TRAVEL}
										/>
										<RALink title="Jet 1 Suites" href={PATH_ROUTES.PATH_SERVICE_JET_ONE_SUITES} />
										<RALink title="Air Freight" href={PATH_ROUTES.PATH_SERVICE_AIR_FREIGHT} />
									</WrapperLink>
								</Panel>
								<Panel
									header={<RATypography variant="h5">{"Help & Support"}</RATypography>}
									key="3"
									extra={null}
								>
									<WrapperLink>
										<RALink title="Privacy Policy" href={PATH_ROUTES.PATH_PRIVACY_POLICY} />
										<RALink title="Cookie Policy" href={PATH_ROUTES.PATH_COOKIE_POLICY} />
										<RALink title="Terms & Conditions" href={PATH_ROUTES.PATH_TERM_CONDITIONS} />
										<RALink title="FAQs" href={PATH_ROUTES.PATH_FAQs} />
									</WrapperLink>
								</Panel>
							</Collapse>
						</Row>
						<Divider style={{ margin: "20px 0" }} />
						<WrapperEnding>
							<RATypography variant="sub-heading4" align="center">
								Copyright © 2026 Royal Air Charter
							</RATypography>
							<RATypography variant="sub-heading4" align="center">
								All Rights Reserved.
							</RATypography>
							<RATypography variant="p" align="center" color="#595959" top={8}>
								Royal Air Charter operates flights under FAA Part 135 certificate BUHA637C. On certain
								occasions, flights may be arranged through our broker authority under 14 CFR Part 295,
								in which case flights will be operated by an FAA-certificated air carrier with
								operational control.
							</RATypography>
						</WrapperEnding>
					</ContainerFooter>
				</WrapperCardMd>
			)}
		</>
	);
}

const WrapperCardMd = styled.div`
	height: "100%";
	height: "100%";
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	padding: 20px 0px;
	border-top: 1px solid #e9e8e8;
`;
const ContainerFooter = styled.footer`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	max-width: 1442px;
	padding: 0px 136px;
	width: 100%;
	@media (max-width: 1200px) {
		padding: 0px 40px;
	}
	@media (max-width: 991px) {
		padding: 0px 32px;
	}
	@media (max-width: 767px) {
		padding: 0px 24px;
	}
	@media (max-width: 575px) {
		padding: 20px;
	}
	.ant-collapse-header {
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
	.ant-collapse-ghost > .ant-collapse-item > .ant-collapse-content > .ant-collapse-content-box {
		padding-block: 0;
	}
`;
const WrapperContent = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	padding: 20px 0px;
	width: 100%;
`;
const WrapperEnding = styled.div`
	padding: 6px 0 20px 0;
	width: 100%;

	@media (max-width: 767px) {
		padding: 0;
	}
`;
const WrapperLink = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`;
const WrapperPhone = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;
const BodyContainer = styled.div`
	padding: 24px 0px 32px 0px;
	border-top: 1px solid #e9e8e8;
	width: 100%;
	display: flex;
	justify-content: center;
`;
